import React, { Component, cloneElement, useState } from "react";
import {
  List,
  TopToolbar,
  Datagrid,
  TextField,
  DateField,
  SelectInput,
  DeleteButton,
  EditButton,
  RefreshButton,
  required,
  ShowButton,
  Filter,
  TextInput,
  GET_ONE,
  useResourceContext,
  useRecordContext,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import {
  getComplaintTypeChoices,
  getComplaintStatusChoices,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import Modal from "react-responsive-modal";
import moment from "moment";
import { getLocalStorageKey } from "../common/common";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const ComplaintMangerFilter = (props) => (
  <Filter {...props}>
    <TextInput source="business_name" label="Business Name" />
    <TextInput source="business_sap_code" label="Sold To Id" />
    <TextInput source="complaint_number" label="Record Number" />
    <TextInput source="subcategory_name" label="Subcategory Name" />
    {getComplaintTypeChoices().length > 0 && (
      <SelectInput
        source="complaint_type"
        label="Record Type"
        choices={getComplaintTypeChoices()}
        validate={required()}
      />
    )}
    {getComplaintStatusChoices().length > 0 && (
      <SelectInput
        source="complaint_status"
        label="Record Status"
        choices={getComplaintStatusChoices()}
        validate={required()}
      />
    )}
  </Filter>
);

const SubcategoryName = () => {
  const record = useRecordContext();
  return (
    <span>
      {record && record.subcategory_name ? `${record.subcategory_name}` : "-"}
    </span>
  );
};

const ResolutionField = ({ source }) => {
  const record = useRecordContext();
  if (record.complaint_created_at == record.updated_at) {
    return <span>-</span>;
  }
  return (
    <span>{moment(record.updated_at).format("DD/MM/YYYY, HH:mm:ss")}</span>
  );
};

// const topToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };

// const ListActions = ({ resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     return (
//         <TopToolbar>
//             {filters && cloneElement(filters, {
//                 resource,
//                 showFilter,
//                 displayedFilters,
//                 filterValues,
//                 context: 'button',
//             })}
//             <RefreshButton />
//             <ExportButton
//                 disabled={total === 0}
//                 resource={resource + '_csv'}
//                 sort={currentSort}
//                 filter={{ ...filterValues, ...permanentFilter }}
//                 exporter={exporter}
//                 maxResults={maxResults}
//             />
//         </TopToolbar>
//     )
// }

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;

//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }

//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//         {
//           console.log('xxxx', csvResource)
//         }
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center>
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//   }

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });
    } else {
      setCustomFilterUrl(
        location.search
        // 'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D'
      );
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          // this.setState({ modalShow: true});
          // this.setState({ modalMsg: msg});
        });

      // this.setState(
      //   {
      //     customFilterUrl:
      //       'filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D',
      //   },
      //   () => {
      //     fetch(
      //       `${apiUrl}/${props.resource}_csv?${customFilterUrl}`,
      //       options
      //     )
      //       .then((res) => {
      //         return res.json();
      //       })
      //       .then((jsonD) => {
      //         console.log("json= inside callback", jsonD.data);
      //         const msg = jsonD.data ? jsonD.data[0].message : "";
      //         Swal.fire({
      //           html: msg,
      //           icon: "success",
      //         });
      //         // this.setState({ modalShow: true});
      //         // this.setState({ modalMsg: msg});
      //       });
      //   }
      // );
    }
  };
  // exporterModal = () => {
  //   return "";
  // };

  const onClose = () => {
    // this.setState({ modalShow: false });
    setModalShow(false);
  };
  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
            onClick={(e) => this.callExport(e)}
            disabled={total === 0}
            resource={csvResource}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
            exporter={this.exporterModal}
            maxResults={maxResults}
          /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const patchResendComTicket = (props) => {
  let dataToSend = {
    complaint_number: props?.complaint_number,
  };

  console.log("duppppppppppppppppppp", dataToSend, props);

  const options = CommonHeaderOption();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  options.method = "PATCH";
  options.body = JSON.stringify(dataToSend);
  fetch(`${apiUrl}/resend_sfdc_complaint?complaint_number=${props?.complaint_number}`, options)
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      if (json) {
        console.log("json reply", json, props);
        // setTimeout(()=>{
        if (json.message == "ERROR") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to process your request at this time. Please try again later.",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        } else {
          Swal.fire({
            html: "Successful",
            icon: "success",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        }
      }
    }).catch(error => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Unable to process your request at this time. Please try again later.",
      }).then((result) => {
        // window.location.reload();
        console.log('eroror', error);
        // navigate(`/discount_schemes/${json.id}/show`)
      });
  });
};


const ResendComplaintTicketButton = () => {
  const record = useRecordContext();
  return (
    <div>
      <button
        className="ds-button"
        // onClick={()=>setModalDupShow(!modalDupShow)}
        onClick={() => {
          Swal.fire({
            text: "Are you sure you want to re-send this complaint?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              patchResendComTicket(record);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }}
      >
        <span>Re-Send Complaint Ticket</span>
      </button>
    </div>
  );
};

const ComplaintManagementsList = (props) => {
  // state = {
  //     moodalShow: false,
  // }
  // exporter = (data) => {
  //     const msg = data[0].message;
  //     this.setState({
  //         moodalShow: true,
  //         modalMsg: msg,
  //     })
  // }

  // onClose = () => {
  //     this.setState({
  //         moodalShow: false,
  //     })
  // }

  const showReferenceNo = getLocalStorageKey("show_reference_no");
  const sfdcComplaints = getLocalStorageKey("sfdc_complaints");
  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          // {...props}
          // exporter={this.exporter}
          sort={{ field: "complaint_created_at", order: "DESC" }}
          filters={<ComplaintMangerFilter />}
          title="Contact Us "
          actions={<ListActions permissions={props} />}
        >
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source="business_name" label="Business Name" />
            <TextField source="business_sap_code" label="Sold To Id" />
            <TextField source="complaint_type" label="Record Type" />
            <TextField source="complaint_number" label="Record Number" />
            <TextField source="category_name" label="Category Name" />
            <SubcategoryName
              source="subcategory_name"
              label="Subcategory Name"
            />
            {showReferenceNo && showReferenceNo.show && (
              <TextField source="reference_number" />
            )}
            <TextField source="complaint_status" label="Record Status" />
            <DateField
              source="complaint_created_at"
              label="Record Created At"
              showTime={true}
            />
            <ResolutionField
              source="updated_at"
              label="Resolution Timestamp 123"
              showTime={true}
            />
            {/* <ResolutionField source="updated_at" label="Resolution Timestamp" /> */}
            <ShowButton />
            {!sfdcComplaints && <EditButton />}
            {!sfdcComplaints && <DeleteButton />}
            {/* {sfdcComplaints &&<ResendComplaintTicketButton />} */}
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </React.Fragment>
  );
};

export default ComplaintManagementsList;
